import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/index.scss';
import LoginPage from './js/components/_LoginPage.js';
import reportWebVitals from './reportWebVitals';

import {Provider} from 'react-redux'
import store from './js/store/_store'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <LoginPage/>
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
